import { ReservationDeviceOrigin } from '@/types-aggregatore';

const SESSION_KEY = 'elty.inclinic.reservationDeviceOrigin';

export const persistReservationChannelToSession = (channel: ReservationDeviceOrigin): void => {
  if (typeof window === 'undefined') {
    return;
  }

  if (channel === ReservationDeviceOrigin.App) {
    sessionStorage.setItem(SESSION_KEY, channel);
  } else {
    sessionStorage.removeItem(SESSION_KEY);
  }
};

export const readReservationChannelFromSession = (): ReservationDeviceOrigin | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  const raw = sessionStorage.getItem(SESSION_KEY);
  return raw === ReservationDeviceOrigin.App ? ReservationDeviceOrigin.App : null;
};
